import React from "react";
// import Logo from "../assets/logo.png";

const Header = () => {
  return (
    <header>
      <div>
        {/* <img alt="logo" src={Logo} width={200} /> */}
      </div>
      <nav>
        <ul>
          <li className="cursor" onClick={() => {
            window.open("https://www.omni-united.com", "_blank")
          }}>Home</li>
          <li className="cursor" onClick={() => {
            window.open("https://www.omni-united.com/contact-us", "_blank")
          }}>Contact Us</li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
